import { render, staticRenderFns } from "./SidebarActions.vue?vue&type=template&id=302851d8&scoped=true&"
import script from "./SidebarActions.vue?vue&type=script&lang=js&"
export * from "./SidebarActions.vue?vue&type=script&lang=js&"
import style0 from "./SidebarActions.vue?vue&type=style&index=0&id=302851d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302851d8",
  null
  
)

export default component.exports